(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((search) => search.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);
  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    event.target.style.setProperty('--account-dialog-top', `${Math.max(0, Math.round(event.target.getBoundingClientRect().bottom))}px`);
  }, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wadl-consent"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wadl-consent-preview')) {
    class WadlConsentPreview extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const on = (el, name, fn) => el.addEventListener(name, fn, {signal: this.controller.signal});
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.options = this.querySelector('.wc-options');
        this.optionsButton = this.querySelector('[data-wc-options]');
        this.status = this.querySelector('[data-wc-status]');
        this.choice = {preferences: false, analytics: false, marketing: false};
        const show = () => {
          for (const [key, value] of Object.entries(this.choice)) this.querySelector('input[name="' + key + '"]').checked = value;
          if (!this.dialog.open) this.dialog.showModal();
        };
        const toggleOptions = (expanded) => {
          this.options.hidden = !expanded;
          this.optionsButton.setAttribute('aria-expanded', String(expanded));
        };
        const save = (all) => {
          for (const key of Object.keys(this.choice)) {
            this.choice[key] = typeof all === 'boolean' ? all : this.querySelector('input[name="' + key + '"]').checked;
          }
          this.status.textContent = this.querySelector('[data-wc-saved]').textContent;
          this.dialog.close();
          this.querySelector('[data-wc-open]').focus();
        };
        on(this.querySelector('[data-wc-open]'), 'click', show);
        on(this.querySelector('[data-wc-close]'), 'click', () => this.dialog.close());
        on(this.optionsButton, 'click', () => toggleOptions(this.options.hidden));
        on(this.querySelector('[data-wc-reject]'), 'click', () => save(false));
        on(this.querySelector('[data-wc-accept]'), 'click', () => save(true));
        on(this.querySelector('[data-wc-save]'), 'click', () => save());
        on(this.querySelector('[data-wc-reset]'), 'click', () => {
          this.choice = {preferences: false, analytics: false, marketing: false};
          show();
          toggleOptions(false);
          this.status.textContent = this.querySelector('[data-wc-reset-text]').textContent;
        });
        on(document, 'shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) show();
        });
        on(document, 'shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
        });
        on(document, 'shopify:block:select', (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          show();
          toggleOptions(true);
          const details = event.target.closest('details');
          if (details) { details.open = true; details.scrollIntoView({block: 'nearest'}); }
        });
        if (this.dataset.open === 'true') show();
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    }
    customElements.define('wadl-consent-preview', WadlConsentPreview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wadl-insta-feed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const expire = () => {
    document.querySelectorAll('.wadl-insta [data-insta-expires]').forEach(item => {
      if (Number(item.dataset.instaExpires) * 1000 <= Date.now()) item.remove();
    });
    if (!window.Shopify?.designMode) document.querySelectorAll('.wadl-insta').forEach(section => {
      section.querySelectorAll('.wadl-insta__bubbles').forEach(row => { row.hidden = !row.querySelector('.wadl-insta__bubble'); });
      if (!section.querySelector('.wadl-insta__item')) section.hidden = true;
    });
  };
  expire();
  setInterval(expire, 30000);
  document.addEventListener('shopify:section:load', expire);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wadl-schaufenster"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wadl-schaufenster')){
 customElements.define('wadl-schaufenster',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();
   const signal=this.controller.signal;
   this.observers=[];
   this.querySelectorAll('video').forEach(video=>{
    const button=video.parentElement.querySelector('[data-ws-video-toggle]');
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    let visible=false,userPaused=false,userStarted=false;
    const sync=()=>{if(button){button.setAttribute('aria-label',video.paused?button.dataset.play:button.dataset.pause);button.querySelector('[data-ws-video-symbol]').textContent=video.paused?'▶':'Ⅱ'}};
    const play=()=>video.play().catch(sync);
    const update=()=>{if(visible&&!document.hidden&&!userPaused&&(userStarted||video.dataset.autoplay==='true'&&!motion.matches)){play()}else{video.pause()}};
    button?.addEventListener('click',()=>{if(video.paused){userPaused=false;userStarted=true;play()}else{userPaused=true;video.pause()}},{signal});
    video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});
    motion.addEventListener('change',()=>{userStarted=false;update()},{signal});
    document.addEventListener('visibilitychange',update,{signal});
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update()},{threshold:.15});
    observer.observe(video);this.observers.push(observer);sync();
   });
   if(this.dataset.hoverText!=='true')return;
   const intro=this.querySelector('[data-ws-intro]');if(!intro)return;
   const media=matchMedia('(hover:hover) and (pointer:fine)');let hovered=null;
   const update=()=>{
    const focused=this.contains(document.activeElement)?document.activeElement.closest('[data-ws-card]'):null;
    const id=(hovered||focused)?.dataset.wsCard;
    let active=false;
    intro.querySelectorAll('[data-ws-for]').forEach(span=>{const show=span.dataset.wsFor===id;span.classList.toggle('ws__intro-visible',show);active=active||show;});
    intro.classList.toggle('ws__intro--active',active);
   };
   this.querySelectorAll('[data-ws-card]').forEach(card=>{
    card.addEventListener('pointerenter',()=>{if(media.matches){hovered=card;update()}},{signal});
    card.addEventListener('pointerleave',()=>{hovered=null;update()},{signal});
   });
   this.addEventListener('focusin',update,{signal});
   this.addEventListener('focusout',()=>queueMicrotask(update),{signal});
  }
  disconnectedCallback(){this.controller?.abort();this.observers?.forEach(o=>o.disconnect());this.querySelectorAll('video').forEach(v=>v.pause())}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wadl-shop-the-look"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wadl-shop-look')){
  customElements.define('wadl-shop-look',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.track=this.querySelector('[data-wl-track]');
      this.querySelector('[data-wl-prev]')?.addEventListener('click',()=>this.moveGallery(-1),{signal});
      this.querySelector('[data-wl-next]')?.addEventListener('click',()=>this.moveGallery(1),{signal});
      this.track?.addEventListener('scroll',()=>this.updateGallery(),{signal,passive:true});
      this.querySelectorAll('[data-wl-card]').forEach(card=>card.hidden=true);
      this.setAttribute('data-ready','');
      this.querySelectorAll('.wl-form').forEach(form=>this.updateVariant(form));
      this.addEventListener('click',event=>{
        const marker=event.target.closest('[data-wl-marker]');
        if(marker){const open=marker.getAttribute('aria-expanded')==='true',hovered=this.hoverOpened;this.closeCards(false);this.dismissedScene=null;if(!open||hovered)this.openCard(marker);return;}
        if(event.target.closest('[data-wl-close]'))this.dismissCard();
      },{signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.activeMarker&&!this.dialog?.open){this.dismissCard();event.preventDefault();}},{signal});
      this.addEventListener('pointerover',event=>{
        if(event.pointerType!=='mouse'||this.dataset.hoverOpen!=='true'||!matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)').matches)return;
        const scene=event.target.closest('.wl-scene');
        if(scene&&scene===this.activeMarker?.closest('.wl-scene'))clearTimeout(this.hoverCloseTimer);
        const marker=event.target.closest('[data-wl-marker]');
        if(!marker||marker===this.activeMarker||scene===this.dismissedScene)return;
        clearTimeout(this.hoverOpenTimer);
        this.hoverOpenTimer=setTimeout(()=>{if(marker.isConnected&&marker.matches(':hover')){this.closeCards(false);this.openCard(marker,false);}},Number(this.dataset.hoverDelay)||0);
      },{signal});
      this.addEventListener('pointerout',event=>{
        const marker=event.target.closest('[data-wl-marker]');
        if(marker&&!marker.contains(event.relatedTarget))clearTimeout(this.hoverOpenTimer);
        const scene=event.target.closest('.wl-scene');
        if(!scene||scene.contains(event.relatedTarget))return;
        if(this.dismissedScene===scene)this.dismissedScene=null;
        if(this.hoverOpened)this.hoverCloseTimer=setTimeout(()=>{if(this.hoverOpened&&!scene.matches(':hover')&&!scene.contains(document.activeElement))this.closeCards(false);},250);
      },{signal});
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.hoverOpened&&!this.dialog?.open){this.dismissCard();event.preventDefault();}},{signal});
      this.addEventListener('change',event=>{if(event.target.matches('[data-wl-variant]')){const form=event.target.closest('form');this.updateVariant(form);this.positionCard(this.activeMarker);}},{signal});
      this.addEventListener('submit',event=>{if(event.target.matches('.wl-form')){event.preventDefault();this.addToCart(event.target);}},{signal});
      document.addEventListener('click',event=>{if(!this.contains(event.target))this.closeCards(false);},{signal});
      document.addEventListener('shopify:block:select',event=>{const marker=Array.from(this.querySelectorAll('[data-block-id]')).find(node=>node.dataset.blockId===event.detail.blockId);if(marker){this.closeCards(false);this.openCard(marker);}},{signal});
      this.resizeObserver=new ResizeObserver(()=>{this.updateGallery();this.positionCard(this.activeMarker);});
      this.resizeObserver.observe(this);
      if(this.track)this.resizeObserver.observe(this.track);
      this.setupExperience(signal);
      this.updateGallery();
      this.querySelectorAll('[data-wl-card],.wl-stage').forEach(node=>this.resizeObserver.observe(node));
    }
    setupExperience(signal){
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');
      this.userPaused=this.motion.matches;
      this.dialog=this.querySelector('[data-wl-dialog]');
      this.addEventListener('click',event=>{
        const zoom=event.target.closest('[data-wl-zoom]');
        if(zoom){this.openZoom(zoom.closest('.wl-scene'),zoom);return;}
        if(this.dataset.zoom==='true'&&event.target.closest('.wl-stage picture')&&!this.dialog?.open){const scene=event.target.closest('.wl-scene');this.openZoom(scene,scene.querySelector('[data-wl-zoom]'));}
        if(event.target.closest('[data-wl-zoom-close]'))this.closeZoom();
      },{signal});
      this.dialog?.addEventListener('click',event=>{if(event.target===this.dialog)this.closeZoom();},{signal});
      this.dialog?.addEventListener('cancel',event=>{event.preventDefault();this.closeZoom();},{signal});
      this.dialog?.addEventListener('close',()=>this.restoreZoom(),{signal});
      this.querySelector('[data-wl-autoplay]')?.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.updateAutoplayButton();this.scheduleAutoplay();},{signal});
      this.addEventListener('pointerenter',()=>{this.pointerInside=true;this.scheduleAutoplay();},{signal});
      this.addEventListener('pointerleave',()=>{this.pointerInside=false;this.scheduleAutoplay();},{signal});
      this.addEventListener('focusin',()=>this.scheduleAutoplay(),{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>this.scheduleAutoplay()),{signal});
      this.track?.addEventListener('pointerdown',()=>{this.dragging=true;this.scheduleAutoplay();},{signal});
      window.addEventListener('pointerup',()=>{this.dragging=false;this.scheduleAutoplay();},{signal});
      window.addEventListener('pointercancel',()=>{this.dragging=false;this.scheduleAutoplay();},{signal});
      this.track?.addEventListener('scroll',()=>this.scheduleAutoplay(),{signal,passive:true});
      document.addEventListener('visibilitychange',()=>this.scheduleAutoplay(),{signal});
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.userPaused=true;this.updateAutoplayButton();this.scheduleAutoplay();},{signal});
      this.visibilityObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.scheduleAutoplay();},{threshold:.15});
      this.visibilityObserver.observe(this);
      document.fonts?.ready.then(()=>{if(this.isConnected)this.alignSceneHeadings();});
      this.updateAutoplayButton();
    }
    updateAutoplayButton(){const button=this.querySelector('[data-wl-autoplay]');if(button){const label=this.userPaused?this.dataset.playLabel:this.dataset.pauseLabel;button.querySelector('[data-wl-pause-text]').textContent=label;button.setAttribute('aria-label',label);button.setAttribute('aria-pressed',String(this.userPaused));}}
    scheduleAutoplay(){
      clearTimeout(this.autoplayTimer);
      if(this.dataset.autoplay!=='true'||this.userPaused||this.motion?.matches||!this.inView||document.hidden||this.pointerInside||this.dragging||this.contains(document.activeElement)||this.activeMarker||this.dialog?.open||this.track?.dataset.carousel!=='true'||this.track.scrollWidth-this.track.clientWidth<2)return;
      this.autoplayTimer=setTimeout(()=>{
        if(this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2)this.track.scrollTo({left:0,behavior:'smooth'});
        else this.moveGallery(1);
        this.scheduleAutoplay();
      },Math.max(3,Number(this.dataset.interval)||6)*1000);
    }
    openZoom(scene,trigger){
      if(!this.dialog||this.dialog.open||!scene)return;
      this.closeCards(false);
      this.zoomScene=scene;this.zoomTrigger=trigger;
      const from=scene.getBoundingClientRect();
      this.placeholder=document.createElement('div');this.placeholder.className='wl-scene wl-zoom-placeholder';this.placeholder.style.height=from.height+'px';this.placeholder.setAttribute('aria-hidden','true');
      scene.replaceWith(this.placeholder);
      this.dialog.querySelector('[data-wl-zoom-content]').append(scene);
      this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
      this.dialog.showModal();
      this.dialog.querySelector('[data-wl-zoom-close]').focus({preventScroll:true});
      if(!this.motion.matches){const to=scene.getBoundingClientRect();this.zoomAnimation=scene.animate([{transform:`translate(${from.left-to.left}px,${from.top-to.top}px) scale(${from.width/to.width})`,opacity:.6},{transform:'none',opacity:1}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)',fill:'none'});}
      this.scheduleAutoplay();
    }
    closeZoom(){if(this.dialog?.open)this.dialog.close();this.restoreZoom();}
    restoreZoom(){
      if(!this.zoomScene)return;
      this.zoomAnimation?.cancel();this.closeCards(false);
      this.placeholder.replaceWith(this.zoomScene);this.zoomScene=null;this.placeholder=null;
      document.documentElement.style.overflow=this.oldOverflow;
      this.zoomTrigger?.focus({preventScroll:true});this.zoomTrigger=null;
      this.updateGallery();this.scheduleAutoplay();
    }
    alignSceneHeadings(){
      if(!this.track)return;
      const copies=Array.from(this.track.querySelectorAll(':scope > .wl-scene > .wl-scene-copy'));
      const heights=copies.map(copy=>Array.from(copy.children).reduce((total,child)=>{const css=getComputedStyle(child);return total+child.getBoundingClientRect().height+parseFloat(css.marginTop||0)+parseFloat(css.marginBottom||0);},0));
      const height=Math.ceil(Math.max(0,...heights));
      const value=height+'px';if(this.track.style.getPropertyValue('--wl-copy-height')!==value)this.track.style.setProperty('--wl-copy-height',value);
    }
    updateGallery(){
      this.alignSceneHeadings();
      if(!this.track)return;
      const carousel=getComputedStyle(this.track).display==='flex';
      this.track.dataset.carousel=String(carousel);
      const nav=this.querySelector('[data-wl-nav]');
      this.scheduleAutoplay();
      if(!nav)return;
      const max=this.track.scrollWidth-this.track.clientWidth;
      nav.hidden=!carousel||max<2;
      const left=this.track.scrollLeft;
      const prev=this.querySelector('[data-wl-prev]'),next=this.querySelector('[data-wl-next]');if(prev)prev.disabled=left<=2;
      if(next)next.disabled=left>=max-2;
      const bounds=this.track.getBoundingClientRect(),items=Array.from(this.track.children);
      const visible=items.map((item,index)=>({bounds:item.getBoundingClientRect(),index})).filter(item=>item.bounds.right>bounds.left+2&&item.bounds.left<bounds.right-2);
      if(visible.length){const first=visible[0].index+1,last=visible.at(-1).index+1;this.querySelector('[data-wl-counter]').textContent=(first===last?first:first+'–'+last)+' / '+items.length;}const progress=this.querySelector('[data-wl-progress]');if(progress)progress.style.width=Math.max(0,Math.min(100,(this.track.clientWidth+left)/this.track.scrollWidth*100))+'%';
    }
    moveGallery(direction){
      if(!this.track)return;
      this.closeCards(false);
      const first=this.track.firstElementChild;
      const step=first?first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap||0):this.track.clientWidth;
      this.track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    disconnectedCallback(){this.closeZoom();clearTimeout(this.autoplayTimer);this.visibilityObserver?.disconnect();clearTimeout(this.hoverOpenTimer);clearTimeout(this.hoverCloseTimer);this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect();}
    closeCards(focus){clearTimeout(this.hoverOpenTimer);clearTimeout(this.hoverCloseTimer);this.hoverOpened=false;const marker=this.activeMarker;this.querySelectorAll('[data-wl-card]').forEach(card=>card.hidden=true);this.querySelectorAll('[data-wl-marker]').forEach(node=>node.setAttribute('aria-expanded','false'));this.querySelectorAll('.wl-scene').forEach(scene=>scene.style.minHeight='');this.activeMarker=null;this.scheduleAutoplay();if(focus)marker?.focus();}
    dismissCard(){this.dismissedScene=this.activeMarker?.closest('.wl-scene');this.closeCards(!this.hoverOpened);}
    openCard(marker,focus=true){const card=this.querySelector('#'+CSS.escape(marker.getAttribute('aria-controls')));if(!card)return;card.dataset.hoverReveal=String(!focus);card.hidden=false;marker.setAttribute('aria-expanded','true');this.activeMarker=marker;this.scheduleAutoplay();this.hoverOpened=!focus;this.revealScene(marker);this.positionCard(marker);if(focus)card.focus({preventScroll:true});}
    revealScene(marker){
      if(this.dialog?.open||!this.track||this.track.dataset.carousel!=='true')return;
      const bounds=this.track.getBoundingClientRect(),scene=marker.closest('.wl-scene').getBoundingClientRect();
      const shift=scene.left<bounds.left?scene.left-bounds.left:scene.right>bounds.right?scene.right-bounds.right:0;
      this.track.scrollTo({left:this.track.scrollLeft+shift,behavior:'instant'});
    }
    positionCard(marker){
      if(!marker||!marker.isConnected)return;
      const card=this.querySelector('#'+CSS.escape(marker.getAttribute('aria-controls')));
      if(!card||card.hidden)return;
      const scene=marker.closest('.wl-scene');
      const bounds=scene.getBoundingClientRect(),stage=scene.querySelector('.wl-stage').getBoundingClientRect(),spot=marker.getBoundingClientRect();
      const inset=Math.min(8,stage.width/10,stage.height/10),gap=10;
      const minX=stage.left-bounds.left+inset,minY=stage.top-bounds.top+inset;
      const availableWidth=Math.max(1,stage.width-2*inset),availableHeight=Math.max(1,stage.height-2*inset);
      card.dataset.density=availableHeight<190||availableWidth<300?'tight':availableWidth<620?'compact':'regular';
      card.style.width=Math.min(availableWidth,Math.max(280,Math.min(380,stage.width*.6)))+'px';
      card.style.maxHeight=availableHeight+'px';
      if(card.scrollHeight>card.clientHeight+1){
        card.dataset.density='tight';
        card.style.width=Math.min(380,availableWidth)+'px';
      }
      const width=card.offsetWidth,height=card.offsetHeight;
      const maxX=minX+availableWidth-width,maxY=minY+availableHeight-height;
      const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));
      const x=spot.left-bounds.left,y=spot.top-bounds.top;
      const centered=clamp(x+spot.width/2-width/2,minX,maxX);
      let left=centered,top;
      if(y-height-gap>=minY){top=y-height-gap;}
      else if(y+spot.height+gap+height<=minY+availableHeight){top=y+spot.height+gap;}
      else if(x+spot.width+gap+width<=minX+availableWidth){left=x+spot.width+gap;top=clamp(y+spot.height/2-height/2,minY,maxY);}
      else if(x-width-gap>=minX){left=x-width-gap;top=clamp(y+spot.height/2-height/2,minY,maxY);}
      else{top=clamp(y+spot.height/2-height/2,minY,maxY);}
      card.style.left=clamp(left,minX,maxX)+'px';card.style.top=clamp(top,minY,maxY)+'px';
      scene.style.minHeight='';
    }
    updateVariant(form){
      const select=form.querySelector('[name=id]'),option=select?.selectedOptions?.[0]||select,button=form.querySelector('[data-wl-submit]'),card=form.closest('[data-wl-card]');
      if(!select||!button)return;
      button.disabled=!select.value||option.dataset.purchasable!=='true'||form.dataset.pending==='true'||form.dataset.uncertain==='true';
      const price=card.querySelector('[data-wl-price]');if(price&&option.dataset.price)price.textContent=option.dataset.price;
      const link=card.querySelector('[data-wl-product-link]');if(link){const url=new URL(link.dataset.baseUrl,location.origin);if(select.value)url.searchParams.set('variant',select.value);link.href=url.href;const titleLink=card.querySelector('[data-wl-title-link]');if(titleLink)titleLink.href=url.href;}
      const image=card.querySelector('.wl-product-image');
      const variantName=card.querySelector('[data-wl-variant-name]'),variantTitle=card.querySelector('[data-wl-variant-title]');
      if(variantName&&variantTitle){const title=select.value?option?.dataset.variantTitle||'':'';variantTitle.textContent=title;variantName.hidden=!title;}
      if(image&&select.value&&option?.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.imageAlt||'';}
    }
    async addToCart(form){
      const button=form.querySelector('[data-wl-submit]'),status=form.querySelector('[data-wl-status]'),variant=form.querySelector('[name=id]');
      if(button.disabled||form.dataset.pending==='true'||form.dataset.uncertain==='true')return;
      if(!form.reportValidity())return;
      form.dataset.pending='true';button.disabled=true;variant.disabled=true;status.textContent='';
      const data=new FormData(form);data.set('id',variant.value);
      const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
      const root=window.Shopify?.routes?.root||'/';
      if(cart?.getSectionsToRender){data.set('sections',cart.getSectionsToRender().map(section=>section.id).join(','));data.set('sections_url',location.pathname);cart.setActiveElement?.(this.activeMarker||button);}
      let confirmed=false,explicitFailure=false;
      try{
        const url=new URL(form.action);url.pathname=url.pathname.replace(/\/add\/?$/,'/add.js');
        const response=await fetch(url,{method:'POST',body:data,headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},signal:AbortSignal.timeout(30000)});
        const result=await response.json();
        if(!response.ok||result.status){explicitFailure=true;status.textContent=typeof result.description==='string'?result.description:this.dataset.error;return;}
        confirmed=true;status.textContent=this.dataset.success;
        if(cart?.renderContents&&result.sections&&Object.values(result.sections).every(Boolean)){
          try{this.closeZoom();this.closeCards(false);cart.classList.remove('is-empty');cart.renderContents(result);}catch{location.assign(root+'cart');}
        }else{location.assign(root+'cart');}
      }catch{
        if(confirmed){location.assign(root+'cart');}
        else if(!explicitFailure){form.dataset.uncertain='true';status.textContent=this.dataset.uncertain;}
      }finally{
        form.dataset.pending='false';variant.disabled=false;this.updateVariant(form);this.positionCard(this.activeMarker);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
